export const TWILIO_SMS_REGIONS = ['us', 'eu'];
const TWILIO_SMS_REGION_SET = new Set(TWILIO_SMS_REGIONS);
const TWILIO_SMS_CLIENT_REGION_CONFIG = {
    eu: {
        edge: 'dublin',
        region: 'ie1',
    },
};
export function assertAllowedTwilioSmsRegion(region) {
    const normalized = (region ?? 'us').trim().toLowerCase();
    if (!normalized || !TWILIO_SMS_REGION_SET.has(normalized)) {
        throw new Error(`Invalid Twilio SMS region. Allowed regions: ${TWILIO_SMS_REGIONS.join(', ')}.`);
    }
    return normalized;
}
export function getTwilioSmsClientRegionConfig(region) {
    const normalizedRegion = assertAllowedTwilioSmsRegion(region);
    if (normalizedRegion === 'us') {
        return undefined;
    }
    return TWILIO_SMS_CLIENT_REGION_CONFIG[normalizedRegion];
}
//# sourceMappingURL=twilio-sms-regions.js.map